angular.module("UI8.filters").filter("ui8FormatNumber", [
  "$filter",
  function () {
    return function (value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };
  },
]);
